<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{
  reaction?: '' | 'like' | 'dislike'
  comment?: string
  submittedAt?: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  submit: [reaction: '' | 'like' | 'dislike', comment: string]
}>()

const draftComment = ref(props.comment || '')

watch(
  () => props.comment,
  (value) => {
    draftComment.value = value || ''
  },
)

function chooseReaction(value: 'like' | 'dislike') {
  const nextValue = props.reaction === value ? '' : value
  emit('submit', nextValue, draftComment.value.trim())
}

function saveComment() {
  emit('submit', props.reaction || '', draftComment.value.trim())
}
</script>

<template>
  <section class="message-feedback" aria-label="回答评价">
    <div class="message-feedback-heading">
      <span>评价本回答</span>
      <small>选填，不评价也可以继续提问</small>
    </div>
    <div class="message-feedback-reactions">
      <button
        type="button"
        :class="{ active: reaction === 'like' }"
        :aria-pressed="reaction === 'like'"
        :disabled="disabled"
        @click="chooseReaction('like')"
      >
        <span aria-hidden="true">👍</span> 赞
      </button>
      <button
        type="button"
        :class="{ active: reaction === 'dislike' }"
        :aria-pressed="reaction === 'dislike'"
        :disabled="disabled"
        @click="chooseReaction('dislike')"
      >
        <span aria-hidden="true">👎</span> 踩
      </button>
    </div>
    <label class="message-feedback-comment">
      <span>你的评价 <small>（选填）</small></span>
      <textarea
        v-model="draftComment"
        rows="2"
        maxlength="2000"
        :disabled="disabled"
        placeholder="可以补充具体意见"
      ></textarea>
    </label>
    <div class="message-feedback-footer">
      <span v-if="submittedAt" class="feedback-saved">已保存</span>
      <button
        class="feedback-save-button"
        type="button"
        :disabled="disabled"
        @click="saveComment"
      >
        {{ disabled ? '保存中…' : '保存评价' }}
      </button>
    </div>
  </section>
</template>
